import { getModifiersList as fetchModifiersList } from '@/services/goods.service';

function defaultState() {
  return {
    modifiers: [],
    isModifiersLoaded: false,
    isModifiersLoading: false,
    modifiersRequest: null,
    modifiersByPointId: {},
    isModifiersLoadedByPointId: {},
    isModifiersLoadingByPointId: {},
    modifiersRequestByPointId: {},
  };
}

export default {
  namespaced: true,
  state: defaultState,
  getters: {
    modifiersByPoint: (state) => (pointId) => state.modifiersByPointId?.[pointId] || [],
    isModifiersLoadedByPoint: (state) => (pointId) => !!state.isModifiersLoadedByPointId?.[pointId],
    isModifiersLoadingByPoint: (state) => (pointId) => !!state.isModifiersLoadingByPointId?.[pointId],
  },
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_MODIFIERS(state, { pointId, modifiers } = {}) {
      const normalizedModifiers = Array.isArray(modifiers) ? modifiers : [];

      state.modifiers = normalizedModifiers;
      state.isModifiersLoaded = true;

      if (!pointId) return;

      state.modifiersByPointId = {
        ...state.modifiersByPointId,
        [pointId]: normalizedModifiers,
      };
      state.isModifiersLoadedByPointId = {
        ...state.isModifiersLoadedByPointId,
        [pointId]: true,
      };
    },
    SET_LOADING(state, { pointId, status }) {
      state.isModifiersLoadingByPointId = {
        ...state.isModifiersLoadingByPointId,
        [pointId]: status,
      };
    },
    SET_REQUEST(state, { pointId, request }) {
      state.modifiersRequestByPointId = {
        ...state.modifiersRequestByPointId,
        [pointId]: request,
      };
    },
    // Метод для принудительного сброса кэша (например, после создания/удаления модификатора)
    INVALIDATE_CACHE(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    /**
     * Получает список модификаторов.
     * Если данные уже загружены в стейт и forceRefresh === false,
     * возвращает данные из кэша, не делая запрос на сервер.
     */
    async loadModifiers({ commit, getters, state }, { pointId, forceRefresh = false } = {}) {
      if (!pointId) {
        throw new Error('pointId is required for goods/loadModifiers');
      }

      if (getters.isModifiersLoadedByPoint(pointId) && !forceRefresh) {
        return getters.modifiersByPoint(pointId);
      }

      if (getters.isModifiersLoadingByPoint(pointId)) {
        return state.modifiersRequestByPointId[pointId] || getters.modifiersByPoint(pointId);
      }

      commit('SET_LOADING', { pointId, status: true });
      const request = fetchModifiersList(pointId);
      commit('SET_REQUEST', { pointId, request });
      try {
        const modifiers = await request;
        commit('SET_MODIFIERS', { pointId, modifiers });
        return modifiers;
      } catch (error) {
        console.error('goods module -> loadModifiers error:', error);
        throw error;
      } finally {
        commit('SET_REQUEST', { pointId, request: null });
        commit('SET_LOADING', { pointId, status: false });
      }
    },

    /**
     * Принудительно инвалидировать кэш
     */
    invalidateCache({ commit }, { pointId } = {}) {
      commit('INVALIDATE_CACHE', pointId);
    },
  },
};
